export default function reportPackageGeneratedPackageDirective() {
  return {
    template: require('./report-package-generated-package.html'),
    controller: 'PRReportPackageGeneratedPackageController',
    controllerAs: 'prReportPackageGeneratedPackageVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportPackageGeneratedPackageItem: '=',
    },
  };
}
